import { useHistory } from 'react-router-dom'
import { mapDashboardStatusToPaymentStatus } from '../helper/mapFilterStatus'

export default function useDashboardRedirect() {
  const history = useHistory()

  const redirectToManageOrders = (params = {}) => {
    const { dateRangeOrder, paymentStatus, searchString, dateRangeEvent, eventId, status } = params
    let finalPaymentStatus = paymentStatus || []
    if (status && finalPaymentStatus.length === 0) {
      finalPaymentStatus = mapDashboardStatusToPaymentStatus(status)
    }

    const url = eventId ? `/manage-orders?eventId=${eventId}` : '/manage-orders'
    history.push(url, {
      fromDashboard: true,
      dateRangeOrder,
      dateRangeEvent,
      paymentStatus: finalPaymentStatus,
      searchString: searchString || '',
    })
  }

  return { redirectToManageOrders }
}
